import { render } from "./Table3Charts.vue?vue&type=template&id=0d0411c7&scoped=true"
import script from "./Table3Charts.vue?vue&type=script&lang=js"
export * from "./Table3Charts.vue?vue&type=script&lang=js"

import "./Table3Charts.vue?vue&type=style&index=0&id=0d0411c7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0411c7"]])

export default __exports__